import React from 'react';
import { withRouter } from 'react-router-dom';
import Content from "../../../../components/layout/Content";
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import { parseNumToFixed } from '../../../../utils/common';

const Item = ({ item }) => {
    let modName = '';
    if (item.modifications && item.modifications.length > 0) {
        if (item.idMod) {
            const mod = item.idMod ? item.modifications.find((el) => el.id === item.idMod) : null;
            modName = (mod && mod.title) ? mod.title : '';
        } else {
            modName = '30 см';
        }
    }
    
    return (
        <Content>
            <tr key={item.id} className="kt-datatable__row">
                <td width="200px" className="kt-datatable__cell">
                    <span>{`${item.name} ${modName}`}</span>
                </td>
                <td style={{ textAlign: 'left' }} width="auto" className="kt-datatable__cell">
                    {MEASURES_RAW[item.measure]}
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.quantity, 3) || 0}</span>
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.price) || 0}</span>
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.totalPrice) || 0}</span>
                </td>
            </tr>
        </Content>
    );
};

export const ItemRow = withRouter(Item);
